import React from 'react'
import {BoxProps, useMultiStyleConfig, Text} from '@chakra-ui/react'
import {ProductVariant} from '_types'

interface ProductAttributeSelectorTitleProps {
    variants?: Array<ProductVariant>
    title: string
}

/**
 * @name ProductAttributeSelectorTitle
 *
 * @component
 *
 * @description
 * Renders the title of the product size selector drawer.
 *
 * @returns {React.FC} - The rendered title component.
 */
const ProductAttributeSelectorTitle: React.FC<ProductAttributeSelectorTitleProps> = ({title}) => {
    const styles = useMultiStyleConfig('ProductSizeSelector', {}) as Record<string, BoxProps>

    return (
        <Text {...styles.drawerTitle} as={'h2'}>
            {title}
        </Text>
    )
}

export default ProductAttributeSelectorTitle
